import React from "react";
import Media from "react-media";
import { Route } from "react-router-dom";
import { Subscription } from 'rxjs'
import _ from "lodash";
import Skeleton from 'react-loading-skeleton';
import * as querystring from 'querystring';
import { HeaderDesktop } from "../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../components/header/mobile/HeaderMobile";
import { UsersState } from "../../states/UsersState";
import { UserInfoButton } from "../../components/buttons/user-info-button/UserInfoButton";
import { Button } from "@material-ui/core";
import { ISuperUserDto } from "../../models/SuperUserDto";
import { IUserDto } from "../../models/UserDto";
import { IUsersDto } from "../../models/UsersDto";
import { IDeveloperDto } from "../../models/DeveloperDto";
import { IDevelopersDto } from "../../models/DevelopersDto";
import { SearchBarDesktop } from "../../components/searchbar/desktop/SearchBarDesktop";
import { SearchType } from "../../components/searchbar/SearchType";
import { SearchBarMobile } from "../../components/searchbar/mobile/SearchBarMobile";
import { MposWebPortalApi } from "../../services/api/MposWebPortalApi";
import { UserUtils } from "../../utils/UserUtils";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { ServiceUnavailablePage } from "../service-unavailable-page/ServiceUnavailablePage";
import StateContextProvider from "../../context/StateContext";
import { Mapper } from "../../utils/Mapper";
import './Users.scss'
import { UserType } from "../../utils/UserTypeEnum";

export class Users extends React.Component<any, UsersState> {
    private getSuperUserDetailSubscription: Subscription | null = null;
    private getUsersSubscription: Subscription | null = null;
    private getDevelopersSubscription: Subscription | null = null;

    constructor(props: any) {
        super(props);
        this.state = {
            numberOfUsers: 0,
            numberOfDevelopers: 0,
            usersDto: null,
            userList: [],
            developersDto: null,
            developerList: [],
            isFirstLoading: false,
            isSecondLoading: false,
            superUser: null,
            getUsersError: false,
            superuserDetailsError: false,
            sameTerminalsType: false
        }
    }

    componentDidMount() {

        this.setState({ sameTerminalsType: StateContextProvider.getInstance().getProp("sameTerminalsType") })

        if (this.props.location.state !== undefined && this.props.location.state.data !== undefined) {
            console.log("[Users] Data are valorized!");
            let data = this.props.location.state.data;
            this.props.history.replace('/users', {});
            if (data.redirectTo !== undefined) {
                console.log("[Users] Redirect requested ");
                let redirectTo = data.redirectTo;
                this.props.history.push(redirectTo);
            }
        }

        this.setState({ isFirstLoading: true });

        this.getSuperUserDetailSubscription = MposWebPortalApi.getInstance().getSuperUserDetails().subscribe((superUserDto: ISuperUserDto) => {
            superUserDto.userType = 'AMMINISTRATORE'
            this.setState({
                isFirstLoading: false,
                superUser: superUserDto,
                superuserDetailsError: false,
            });
        }, (error) => {
            this.setState({
                isFirstLoading: false,
                superUser: null,
                superuserDetailsError: true,
            });
        });

        this.setState({ isSecondLoading: true });

        this.getUsersSubscription = MposWebPortalApi.getInstance().getUsers().subscribe((usersDto: IUsersDto) => {
            this.setState({
                usersDto: usersDto,
                userList: usersDto.users !== null ? this.sortListForUsername(usersDto.users) : [],
                numberOfUsers: usersDto.users !== null ? usersDto.users!.length : 0,
                isSecondLoading: false,
            });
            UserUtils.cacheUsers(usersDto);
            this.setState({ getUsersError: false });
        }, (error) => {
            this.setState({
                usersDto: null,
                userList: [],
                numberOfUsers: 0,
                isSecondLoading: false,
                getUsersError: true,
            });
        });

        this.setState({ isSecondLoading: true });

        this.getDevelopersSubscription = MposWebPortalApi.getInstance().getDevelopers().subscribe((developersDto: IDevelopersDto) => {
            this.setState({
                developersDto: developersDto,
                developerList: developersDto.developers !== null ? this.sortListForEmail(developersDto.developers) : [],
                numberOfDevelopers: developersDto.developers !== null ? developersDto.developers!.length : 0,
                isSecondLoading: false,
            });
            UserUtils.cacheDevelopers(developersDto);
            this.setState({ getUsersError: false });
        }, (error) => {
            this.setState({
                developersDto: null,
                developerList: [],
                numberOfDevelopers: 0,
                isSecondLoading: false,
                getUsersError: true,
            });
        });

        GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Le tue utenze', {});
    }

    componentWillUnmount() {
        if (this.getSuperUserDetailSubscription != null) {
            this.getSuperUserDetailSubscription.unsubscribe();
        }

        if (this.getUsersSubscription != null) {
            this.getUsersSubscription.unsubscribe();
        }

        if (this.getDevelopersSubscription != null) {
            this.getDevelopersSubscription.unsubscribe();
        }
    }

    private static renderDesktopHeader(): JSX.Element {
        return (
            <HeaderDesktop showBack={false} showLogout={true} showTitle={false} selectedElement={3} title={"Le tue utenze"} />
        );
    }

    private static renderMobileHeader(): JSX.Element {
        return (
            <HeaderMobile showBack={true} showLogout={true} showTitle={true} title={"LE TUE UTENZE"} />
        );
    }

    private goToUserInfoDetails(history: any, user: any, UserType: any) {
        if (UserType === 'SVILUPPATORE') {
            console.log("[Users] Go to developer details for " + user.email);

            let queryParams = {
                userType: Mapper.mapItalianParamToUserType(UserType),
                description: user.description && user.description !== null ? encodeURIComponent(user.description) : "",
                id: user.id
            };

            let link = `/users/${user.email}?${querystring.stringify(queryParams)}`;

            history.push(link);
        } else {
            console.log("[Users] Go to user details for " + user.username);

            let queryParams = {
                userType: Mapper.mapItalianParamToUserType(UserType),
                description: user.description && user.description !== null ? encodeURIComponent(user.description) : "",
            };

            let link = `/users/${user.username}?${querystring.stringify(queryParams)}`;

            history.push(link);
        }

    }

    private startAddUserFlow(history: any) {
        console.log("[Users] Start add user flow! Going to specific page...");
        history.push('/addUser');
    }

    private sortListForUsername(users: any[] | undefined): any[] {
        if (typeof users !== 'undefined') {
            return users.sort(function (a, b) {
                if (a.username.toLowerCase() < b.username.toLowerCase()) { return -1; }
                if (a.username.toLowerCase() > b.username.toLowerCase()) { return 1; }
                return 0;
            })
        }

        return [];
    }

    private sortListForEmail(users: any[] | undefined): any[] {
        if (typeof users !== 'undefined') {
            return users.sort(function (a, b) {
                if (a.email.toLowerCase() < b.email.toLowerCase()) { return -1; }
                if (a.email.toLowerCase() > b.email.toLowerCase()) { return 1; }
                return 0;
            })
        }

        return [];
    }

    private renderUsersTable(): JSX.Element {
        let elements = new Array<JSX.Element[]>();
        let temporary: JSX.Element[] = [];
        const combinedArray = _.concat<any>(this.state.userList, this.state.developerList);

        _.forEach(combinedArray, (value: any, index: number) => {
            temporary.push(
                <div className={"user-table-column"}>
                    <Route render={({ history }) => {
                        const userTypeMap = Mapper.mapItalianParamToUserType(value.userType);
                        return (
                            <UserInfoButton
                                user={userTypeMap === UserType.DEVELOPER ? value.email : value.username}
                                role={value.description != null ? value.description : userTypeMap === UserType.DEVELOPER ? 'Sviluppatore' : "--"}
                                userType={userTypeMap}
                                terminalList={value.terminalInfo}
                                sameTerminalsType={this.state.sameTerminalsType}
                                onClick={() => this.goToUserInfoDetails(history, value, value.userType)}
                            />
                        )
                    }} />
                </div>
            )

            if (temporary.length === 2) {
                elements.push(temporary);
                temporary = [];
            } else {
                if (index === (combinedArray?.length! - 1)) {
                    elements.push(temporary);
                    temporary = [];
                }
            }
        })

        return (
            <div className={"user-users-table"}>
                {_.map(elements, (rowElements) => {
                    return <div className={"user-table-row"}>
                        {_.map(rowElements, (columnElement) => {
                            return columnElement;
                        })}
                    </div>
                })}
            </div>
        )
    }

    private desktopSearchBarValueProvided(value: string) {
        this.setState({ userList: this.filterElements(value, this.state.usersDto?.users!) });
        this.setState({ developerList: this.filterElements(value, this.state.developersDto?.developers!) });
    }

    private filterElements(filter: string, dto: Array<any>): Array<any> {
        let elements = Array.from(dto);
        if (filter.length >= 3) {
            GoogleTagManagerService.getInstance().pushInteractionEvent('RicercaOverlay', 'le tue utenze', 'search', 'ricerca per utenza');
            return elements.filter((obj: IUserDto | IDeveloperDto) => {
                return obj.email?.toLowerCase().includes(filter.toLowerCase());
            });
        }

        return elements;
    }

    private renderUsersTableSkeleton() {
        return (
            <div className={"user-users-table"}>
                <div className={"user-table-row"}>
                    <div className={"user-table-column user-table-column-left"}>
                        <UserInfoButton isLoading={true} />
                    </div>
                    <div className={"user-table-column user-table-column-right"}>
                        <UserInfoButton isLoading={true} />
                    </div>
                </div>
                <div className={"user-table-row"}>
                    <div className={"user-table-column user-table-column-left"}>
                        <UserInfoButton isLoading={true} />
                    </div>
                    <div className={"user-table-column user-table-column-right"}>
                        <UserInfoButton isLoading={true} />
                    </div>
                </div>
            </div>
        )
    }

    private renderNoUsers() {
        console.log("[Users] renderNoUsers!");
        return (
            <div className={"user-no-user-container"}>
                <p className={"user-no-user-text"}>
                    Invita un collaboratore ad accettare pagamenti a nome della tua attività. Il nuovo utente avrà le proprie credenziali e vedrà solo le transazioni relative all’ID Terminale a lui assegnato.
                </p>
                <Route render={({ history }) => {
                    return (
                        <Button
                            type={"button"}
                            id={"user-create-user-one-button"}
                            onClick={() => this.startAddUserFlow(history)}
                        >
                            CREA UTENZA
                        </Button>
                    )
                }} />
            </div>
        )
    }

    render() {
        return (this.state.superuserDetailsError || this.state.getUsersError) ? <ServiceUnavailablePage /> : <div id={"main-container-users"}>
            <Media query="(max-width: 1064px)" render={() => Users.renderMobileHeader()} />
            <Media query="(min-width: 1065px)" render={() => Users.renderDesktopHeader()} />
            <div className={"users-container-content"}>
                <p className={"user-title"}>IL TUO ACCOUNT</p>
                {
                    <div className={"user-main-account-container"}>
                        <Route render={({ history }) => {
                            console.log('super user ' + JSON.stringify(this.state.superUser))
                            return (
                                <UserInfoButton
                                    isAdmin
                                    isLoading={this.state.isFirstLoading}
                                    user={this.state.superUser?.username!}
                                    role="Amministratore"
                                    sameTerminalsType={this.state.sameTerminalsType}
                                    terminalList={this.state.superUser?.terminalInfo}
                                    onClick={() => this.goToUserInfoDetails(history, UserUtils.mapSuperUserToUserDto(this.state.superUser!), this.state.superUser?.userType)}
                                />
                            )
                        }} />
                    </div>
                }
                <div className={"user-search-bar-header"}>
                    <p className={"user-title"}>LE TUE UTENZE({this.state.numberOfUsers + this.state.numberOfDevelopers})</p>
                    {
                        (this.state.numberOfUsers > 0 || this.state.numberOfDevelopers > 0) && <Route render={({ history }) => {
                            return (
                                <Button id={"button-add-new-user"}
                                    onClick={() => this.startAddUserFlow(history)} disableRipple
                                >
                                    CREA UTENZA
                                </Button>
                            )
                        }} />
                    }
                </div>
                {
                    this.state.isSecondLoading && <div className={"user-search-bar-container"}>
                        <Skeleton className={"user-searchbar-skeleton"} />
                    </div>
                }
                {!this.state.isSecondLoading && (this.state.numberOfUsers + this.state.numberOfDevelopers) > 10 && (
                    <div className={"user-search-bar-container"}>
                        <Media query="(min-width: 1065px)" render={() => {
                            return (
                                <SearchBarDesktop
                                    placeholder="Cerca per username"
                                    onValueChanged={(value: string) => { this.desktopSearchBarValueProvided(value) }}
                                />
                            )
                        }} />
                        <Media query="(max-width: 1064px)" render={() => {
                            return (
                                <SearchBarMobile
                                    values={_.concat<any>(this.state.usersDto?.users, this.state.developersDto?.developers)}
                                    type={SearchType.USER_INFO}
                                    placeholder="Cerca per username"
                                />
                            )
                        }}
                        />
                    </div>
                )}
                {[
                    this.state.isSecondLoading && this.renderUsersTableSkeleton(),
                    !this.state.isSecondLoading && (this.state.numberOfUsers === 0 && this.state.numberOfDevelopers === 0 ? this.renderNoUsers() : this.renderUsersTable())
                ]}
            </div>
        </div>
    }
}